var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.custodianSettingsStore.isLoaded)?_c('TabResponsiveDropDown',{staticClass:"settings-nav p-3 p-md-0",attrs:{"active-tab-index":_vm.activeTabIndex,"tabChoices":_vm.navItems,"tabsTheme":"employee"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }